import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RemoveDecimalPipe } from './pipes/remove-decimal.pipe';
import { FormatNumberReturnViewPipe } from './pipes/format-number-return-view.pipe';
import { NumberConvertBnPipe } from './pipes/number-convert-bn.pipe';
import { ConvertNumWithOtherCharsToBnPipe } from './pipes/convert-num-with-other-chars-to-bn.pipe';
import { CurrencySeparatorBDPipe } from './pipes/currency-separator-bd.pipe';
import { SafeDatePipe } from './pipes/safe-date.pipe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NumberWithCommaSeparatorDirective } from './directives/number-with-comma-separator.directive';
import { NumberWithDecimalPointOnlyDirective } from './directives/number-with-decimal-point-only.directive';
import { OptionsOfTypePipe } from './pipes/options-of-type.pipe';
import { SignedAmountInputComponent } from './components/signed-amount-input/signed-amount-input.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { PasswordPolicyHintsComponent } from './components/password-policy-hints/password-policy-hints.component';


@NgModule({
  declarations: [
    RemoveDecimalPipe,
    FormatNumberReturnViewPipe,
    NumberConvertBnPipe,
    ConvertNumWithOtherCharsToBnPipe,
    CurrencySeparatorBDPipe,
    SafeDatePipe,
    NumberWithCommaSeparatorDirective,
    NumberWithDecimalPointOnlyDirective,
    OptionsOfTypePipe,
    SignedAmountInputComponent,
    OtpInputComponent,
    PasswordPolicyHintsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
  ],
  exports: [
    CommonModule,
    FormsModule,
    RemoveDecimalPipe,
    FormatNumberReturnViewPipe,
    NumberConvertBnPipe,
    ConvertNumWithOtherCharsToBnPipe,
    CurrencySeparatorBDPipe,
    SafeDatePipe,
    NumberWithCommaSeparatorDirective,
    NumberWithDecimalPointOnlyDirective,
    OptionsOfTypePipe,
    SignedAmountInputComponent,
    OtpInputComponent,
    PasswordPolicyHintsComponent
  ]
})
export class SharedModule { }
